import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const WindowsIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M0,3.38236364 L9.73281818,2.05685455 L9.73707273,11.4449455 L0.00889090909,11.5003445 L0,3.38236364 Z M9.72818182,12.5266364 L9.73573636,21.9229091 L0.00755454545,20.5854273 L0.00700909091,12.4636091 L9.72818182,12.5266364 Z M10.9080273,1.88345455 L23.8129364,6.21724894e-15 L23.8129364,11.3255455 L10.9080273,11.4279955 L10.9080273,1.88345455 Z M23.8159364,12.615 L23.8129091,23.8895455 L10.908,22.0681636 L10.8899182,12.5938909 L23.8159364,12.615 Z" />
    </SvgIcon>
);

export default WindowsIcon;
